/**
 * Groups the flyers under ambassadors
 * @param {boolean} includeAll If set to true always returns a record for BAs
 * that don't have codes instead of ommitting them
 */
function groupByBA(codes, ambassadorsR, includeAll = false) {
  var groups = [],
    ambassadors = ambassadorsR.slice(0)
  codes.forEach(code => {
    if (code.ambassadorId === undefined)
      throw new Error('Expected code to have an ambassadorId prop.')
    var group = groups.find(a => a.id == code.ambassadorId)
    if (!group) {
      // Find the matching ambassador
      var ba = ambassadors.find(a => a.id == code.ambassadorId)
      if (!ba) return // It wasn't found just ignore this code
      group = {
        ...ba,
        codes: [],
      }
      groups.push(group)
    }
    group.codes.push(code)
  })

  if (includeAll) {
    ambassadors.forEach(ba => {
      var found = groups.find(g => g.id == ba.id)
      if (!found) {
        groups.push({
          ...ba,
          codes: [],
        })
      }
    })
  }

  // Sort to the top which ones have codes then sort by name
  groups.sort(function(g1, g2) {
    if (g1.codes.length > 0 && g2.codes.length === 0) return -1
    if (g2.codes.length > 0 && g1.codes.length === 0) return 1
    if (g1.name < g2.name) return -1
    if (g1.name > g2.name) return 1
    return 0
  })

  return groups
}

export default groupByBA



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/groupByBA.js